import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { RootState } from '../../../states/containers/store'
import { LangValue } from '../../../states/types/common'
import { format, nowDate, secToHourMinute, startOfLastWeek } from '../../../utils/date'
import { setPath, setUrlParam } from '../../../utils/url'
import Modal from './Modal'
import { URL } from '../../constants/url'
import { updateReadReport } from '../../../states/containers/report/reportSlice'
import { createIntroPage } from '../../../states/containers/common/introPagesSlice'

interface Props {
  display: boolean,
  closeCallback: () => void
}

const WorkStyleConfirmModal: FC<Props> = (props) => {
  const dispatch = useDispatch()
  const { language } = useParams<{ language: LangValue }>()
  const history = useHistory()

  const {
    display,
    closeCallback,
  } = props

  const {
    profile,
  } = useSelector((state: RootState) => state)

  const closeModal = () => {
    closeCallback()
    dispatch(
      createIntroPage(
        URL.WORK_STYLE.path,
        () => { /* do nothing */ },
      ),
    )
  }

  const openReport = () => {
    dispatch(
      createIntroPage(
        URL.WORK_STYLE.path,
        () => {
          closeCallback()
          const targetDate = format(startOfLastWeek(nowDate()), 'YYYY-MM-DD')
          history.push(`${setPath(setUrlParam(
            URL.REPORT_DETAIL_WEEKLY.path,
            [
              { key: 'target', value: "member" },
              { key: 'id', value: profile.id.toString() },
            ],
          ), language)}?date=${targetDate}`)
          dispatch(updateReadReport({ id: profile.id, target: "member", type: "weekly", date: targetDate }))
        },
      ),
    )
  }

  return (
    <Modal
      modalSize="large"
      show={display}
      closeCallback={closeModal}
      closeable
      wrapperClass="work_style_modal"
    >
      <>
        <div className="work_style_header">
          <div className="title">
            あなたの働き方がレポートに反映されました。
          </div>
          <div className="description">
            <p>それぞれの働き方の特徴や職種によって評価における各指標の適性範囲が異なります。</p>
            <p>※ 設定はプロフィールからいつでも変更することができます。</p>
          </div>
        </div>
        <div className="work_style_confirm_body">
          <div className="item_list">
            <div className="item_list_title">
              あなたの働き方
            </div>
            <div className="item">
              <img
                alt=""
                src={`/static/images/occupation/${profile.occupation_id || 0}.png`}
                className="icon"
              />
              <div className="item_title">
                <div>職種</div>
                {profile.occupationList.find((value) => value.id === profile.occupation_id)?.description}
              </div>
            </div>
            <div className="item">
              <img
                alt=""
                src={`/static/images/work_style/${
                  (profile.work_style_ids.length && profile.work_style_ids[0]) || 0
                }.png`}
                className="icon"
              />
              <div className="item_title">
                <div>働き方</div>
                {profile.work_style_list.find((value) => value.id === profile.work_style_ids[0])?.description}
              </div>
            </div>
            <div className="item">
              <div className="text_area">
                <div>
                  {secToHourMinute(profile.base_work_time || 0)}
                </div>
              </div>
              <div className="item_title">
                <div>勤務時間</div>
                {secToHourMinute(profile.base_work_time || 0)}
              </div>
            </div>
          </div>
          <img
            alt=""
            src="/static/images/profile/work_setting_ex.png"
            className="example_image"
          />
        </div>
      </>
      <>
        <button
          type="button"
          className="button"
          onClick={() => openReport()}
        >
          新しいレポートを今すぐ見る
        </button>
      </>
    </Modal>
  )
}

export default WorkStyleConfirmModal
